/** Same-origin paths: CloudFront routes these to the API in every deployed env, Vite proxies them locally. */
export const API_PATHS = {
	trpc: "/trpc",
	activity: "/api/activity",
	advisorChat: "/api/advisor/chat"
} as const;

export const CONVERSATION_ID_HEADER = "x-conversation-id";
